import Model from './Model'

// Company job postings (business admin side). Query params map cleanly:
// where('status', x) -> filter[status]=x, where('q', x) -> filter[q]=x.
export default class JobPosting extends Model {
  resource() {
    return 'job-postings'
  }

  // The API paginates with `per_page`, not vue-api-query's default `limit`.
  parameterNames() {
    return {
      ...super.parameterNames(),
      limit: 'per_page',
    }
  }
}
